import { LIMIT } from '@/constants/ConnectionSettings'
import { API, SearchCondition } from '@/types/Types'
import { useState } from 'react'

const usePagination = (api: API, searchCondition: SearchCondition) => {
  const limit = LIMIT

  const [pageText, setPageText] = useState(0)

  const [displayPage, setDisplayPage] = useState(0)

  if (
    typeof api.content.end_index === 'number' &&
    Math.floor(1 + api.content.end_index / limit) !== displayPage
  ) {
    setDisplayPage(Math.floor(1 + api.content.end_index / limit))
    setPageText(Math.floor(1 + api.content.end_index / limit))
  }

  const getMaxPageCount = () => {
    if (!api.content.result_data) {
      return 0
    }
    if (typeof api.content.result_length !== 'number') {
      return 0
    }
    return Math.ceil(api.content.result_length / limit)
  }

  const hasNext = () => {
    if (!api.content.result_data) {
      return false
    }
    if (typeof api.content.result_length !== 'number') {
      return false
    }
    if (typeof api.content.end_index !== 'number') {
      return false
    }
    return api.content.end_index < api.content.result_length - 1
  }

  const hasPrev = () => {
    if (!api.content.result_data) {
      return false
    }
    if (typeof api.content.start_index !== 'number') {
      return false
    }
    return api.content.start_index > 0
  }

  const gotoLast = () => {
    api.fetchAPIData(
      `searchTMapInfo.php?${searchCondition.getParams()}&limit=${limit}&offset=${
        (getMaxPageCount() - 1) * limit
      }`
    )
  }

  const gotoNext = () => {
    if (typeof api.content.start_index !== 'number') {
      return
    }
    api.fetchAPIData(
      `searchTMapInfo.php?${searchCondition.getParams()}&limit=${limit}&offset=${
        api.content.start_index + limit
      }`
    )
  }

  const gotoPrev = () => {
    if (typeof api.content.start_index !== 'number') {
      return
    }
    api.fetchAPIData(
      `searchTMapInfo.php?${searchCondition.getParams()}&limit=${limit}&offset=${
        api.content.start_index - limit
      }`
    )
  }

  const gotoFirst = () => {
    api.fetchAPIData(`searchTMapInfo.php?${searchCondition.getParams()}&limit=${limit}&offset=0`)
  }

  const jump = () => {
    if (pageText <= 0 || pageText > getMaxPageCount()) {
      return
    }
    api.fetchAPIData(
      `searchTMapInfo.php?${searchCondition.getParams()}&limit=${limit}&offset=${(pageText - 1) * limit}`
    )
  }

  return {
    pageText,
    setPageText,
    getMaxPageCount,
    hasNext,
    hasPrev,
    gotoLast,
    gotoNext,
    gotoPrev,
    gotoFirst,
    jump
  }
}

export { usePagination }
